import { Search, CheckCircle, Rocket, ArrowRight } from 'lucide-react';

export default function HowItWorks() {
  const steps = [
    {
      icon: Search,
      title: 'Search for Your Domain',
      description: 'Enter your desired domain name and check availability instantly.',
      color: 'from-blue-400 to-blue-600',
      bgColor: 'bg-blue-500/10',
    },
    {
      icon: CheckCircle,
      title: 'Register Instantly',
      description: 'Complete your purchase in minutes with our streamlined checkout process.',
      color: 'from-green-400 to-green-600',
      bgColor: 'bg-green-500/10',
    },
    {
      icon: Rocket,
      title: 'Start Building Your Brand',
      description: 'Access your domain immediately and connect it to your website or service.',
      color: 'from-purple-400 to-purple-600',
      bgColor: 'bg-purple-500/10',
    },
  ];

  return (
    <section className="py-20 px-4 sm:px-6 lg:px-8 bg-section-howitworks">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-3xl sm:text-4xl font-bold text-theme-primary mb-4">
            How It Works
          </h2>
          <p className="text-xl text-theme-secondary max-w-3xl mx-auto">
            Get your perfect domain in three simple steps
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {steps.map((step, index) => (
            <div key={index} className="relative group">
              <div className="glass-card p-8 rounded-2xl h-full transition-all duration-300 hover:scale-105">
                {/* Step Number */}
                <div className={`w-16 h-16 ${step.bgColor} rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300`}>
                  <span className={`text-3xl font-bold bg-linear-to-br ${step.color} bg-clip-text text-transparent`}>{index + 1}</span>
                </div>

                {/* Content */}
                <h3 className="text-xl font-bold text-theme-primary mb-3">
                  {step.title}
                </h3>
                <p className="text-theme-secondary mb-4">
                  {step.description}
                </p>

                {/* Arrow indicator */}
                <div className="flex items-center text-blue-500 font-medium opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <span className="mr-2">Learn more</span>
                  <ArrowRight className="h-4 w-4" />
                </div>
              </div>

              {/* Connector for desktop */}
              {index < steps.length - 1 && (
                <div className="hidden md:flex absolute top-1/2 -right-4 transform -translate-y-1/2 z-10">
                  <div className="w-8 h-8 glass-card rounded-full flex items-center justify-center">
                    <ArrowRight className="h-4 w-4 text-blue-500" />
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>

        {/* Bottom CTA */}
        <div className="mt-16 text-center">
          <a
            href="https://domains0.com"
            target="_blank"
            rel="noopener noreferrer"
            className="glass-button text-white px-8 py-4 rounded-lg font-semibold inline-flex items-center gap-2"
          >
            Get Started Now
            <ArrowRight className="h-5 w-5" />
          </a>
        </div>
      </div>
    </section>
  );
}
